import { render, staticRenderFns } from "./BodyDocu.vue?vue&type=template&id=5095f669&scoped=true"
import script from "./BodyDocu.vue?vue&type=script&lang=js"
export * from "./BodyDocu.vue?vue&type=script&lang=js"
import style0 from "./BodyDocu.vue?vue&type=style&index=0&id=5095f669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095f669",
  null
  
)

export default component.exports